import type { CSSProperties } from 'react';
import React from 'react';

import * as styles from './Content.styles';

interface IntroContentCSS extends CSSProperties {
  '--backgroundColor': string;
}

interface IntroContentProps {
  backgroundColor?: string;
  darkCopyColor?: boolean;
  children: React.ReactNode;
}

export const Content = ({
  backgroundColor = 'transparent',
  darkCopyColor = false,
  children,
}: IntroContentProps) => {
  return (
    <div
      css={[styles.contentBackground, darkCopyColor ? styles.copyDark : styles.copyLight]}
      style={{ '--backgroundColor': backgroundColor } as IntroContentCSS}
    >
      <div css={styles.content}>{children}</div>
    </div>
  );
};
